import { Routes } from '@angular/router';
import { TrucksComponent } from './trucks/trucks-fleet-status/trucks.component';
import { TrucksListComponent } from './trucks/trucks-list/trucks-list.component';
import { TrucksReportComponent } from './trucks/trucks-report/trucks-report.component';
import { TrackerMonitorListComponent } from 'src/app/transportation/trucks/tracker-monitor-list/tracker-monitor-list.component';
import { TruckDataEntryComponent } from './trucks/data-entry/truck-data-entry/truck-data-entry.component';
import { VesselsComponent } from './vessels/vessels/vessels.component';
import { VoyagesComponent } from './vessels/voyages/voyages.component';
import { VoyageComponent } from './vessels/voyage/voyage.component';
import { ImportNoonReportComponent } from './vessels/noon-reports/import-noon-report/import-noon-report.component';
import { FleetStatusComponent } from './vessels/fleet-status/fleet-status.component';
import { VoyageReportsComponent } from 'src/app/transportation/vessels/reports/voyage-reports.component';
import { SofTemplateComponent } from './vessels/sof-template/sof-template.component';
import { SofEntryComponent } from './vessels/sof-templates/sof-entry/sof-entry.component';
import { SofTemplatesComponent } from './vessels/sof-templates/sof-templates.component';
import { TankerDataEntryComponent } from './trucks/data-entry/tanker-data-entry/tanker-data-entry.component';
import { TankerListComponent } from './trucks/tanker-list/tanker-list.component';
import { GpsListComponent } from './trucks/gps-list/gps-list.component';
import { GpsDataEntryComponent } from './trucks/data-entry/gps-data-entry/gps-data-entry.component';
import { NauticalMileComponent } from './vessels/nautical-mile/nautical-mile.component';
import { BunkerDataEntryComponent } from './vessels/bunker/bunker-data-entry.component';
import { BunkerListComponent } from './vessels/bunker/bunker-list/bunker-list.component';
import { FleetNavigationHistoryComponent } from './vessels/fleet-navigation-history/fleet-navigation-history.component';
import { BunkerStatusComponent } from './vessels/bunker-status/bunker-status.component';
import { VoyagePlannerComponent } from './vessels/voyage-planner/voyage-planner.component';
import { VesselManagementCostComponent } from './vessels/vessel-management-cost/vessel-management-cost.component';
import { NewVoyageComponent } from './vessels/new-voyage/new-voyage.component';
import { SeaSharkStatusComponent } from './vessels/sea-shark-status/sea-shark.component';
import { NoonReportsV202005Component } from './vessels/noon-reports/noon-reports-v202005/noon-reports-v202005.component';
import { CertificateComponent } from './vessels/certificates/certificate/certificate/certificate.component';
import { CrewChangeComponent } from './vessels/crew-change/crew-change-data-entry/crew-change.component';
import { CrewChangeListComponent } from './vessels/crew-change/crew-changes/crew-changes.component';
import { CrewComponent } from './vessels/crew-change/crew/crew.component';
import { FuelAnalysisComponent } from './vessels/fuel-analysis/fuel-analysis.component';
import { LoadingTimeComponent } from './vessels/loading-time/loading-time.component';
import { NoonReportsV202205Component } from './vessels/noon-reports/noon-reports-v202205/noon-reports-v202205.component';
import { VesselDataEntryComponent } from './vessels/vessel/vessel-data-entry/vessel-data-entry.component';
import { VesselSpecComponent } from './vessels/vessel/vessel-spec/vessel-spec.component';
import { NewVesselComponent } from './vessels/vessel/new-vessel/new-vessel.component';
import { VesselInformationComponent } from './vessels/vessel/vessel-information/vessel-information.component';
import { VesselManualComponent } from './vessels/vessel/vessel-manual/vessel-manuals.component';
import { HelloHelpComponent } from './vessels/hello-help/hello-help.component';

import { FleetPersonnelManagementComponent } from './vessels/crew-change/fleet-personnel/fleet-personnel-management.component';
import { VesselInternalAuditComponent } from './vessels/vessel/vessel-internal-audit/vessel-internal-audit.component';
import { CrewAppraisalComponent } from './vessels/crew-change/appraisal/crew-appraisal.component';
import { CrewProfileComponent } from './vessels/crew-change/crew/crew-profile/crew-profile.component';
import { CrewsAppraisalsComponent } from './vessels/crew-change/crews-appraisals/crews-appraisals.component';
import { VesselOffHireComponent } from './vessels/vessel-off-hire/vessel-off-hire.component';
import { VesselsOffHiresComponent } from './vessels/vessel-off-hire/vessels-off-hires/vessels-off-hires.component';
import { FleetSummeryReportComponent } from 'src/app/transportation/vessels/fleet-status/fleet-summery-report/fleet-summery-report.component';
import { FreshWatersComponent } from './vessels/fresh-waters/fresh-waters.component';
import { FreshWaterComponent } from './vessels/fresh-waters/fresh-water/fresh-water.component';
import { OilDataEntryComponent } from './vessels/oils/oil/oil-component';
import { OilsComponent } from './vessels/oils/oils.component';
import { BlComponent } from './vessels/voyage/bl/bl.component';
import { NorComponent } from './vessels/voyage/nor/nor.component';
import { SofComponent } from './vessels/voyage/sof/sof.component';
import { DischargeComponent } from './vessels/voyage/discharge/discharge.component';
import { CommentComponent } from './vessels/voyage/comment/comment.component';
import { MiscDocumentComponent } from './vessels/voyage/misc-document/misc-document.component';
import { ChartererComponent } from './vessels/voyage/charterer/charterer.component';
import { HelloReleaseComponent } from 'src/app/transportation/vessels/hello-release/hello-release.component';

export const transportationRoutes: Routes = [
  { path: 'trucks', component: TrucksComponent },
  { path: 'trucks/list', component: TrucksListComponent },
  { path: 'trucks/truck', component: TruckDataEntryComponent },
  { path: 'trucks/truck/:truckNumber/:field', component: TruckDataEntryComponent },
  { path: 'trucks/report', component: TrucksReportComponent },
  { path: 'trucks/report/:imei/:startTimestamp/:endTimestamp', component: TrucksReportComponent },
  { path: 'trucks/tanker', component: TankerDataEntryComponent },
  { path: 'trucks/tanker/:tankerNumber/:owner', component: TankerDataEntryComponent },
  { path: 'trucks/tankers', component: TankerListComponent },
  { path: 'trucks/trackers', component: GpsListComponent },
  { path: 'trucks/tracker/monitor', component: TrackerMonitorListComponent },
  { path: 'trucks/tracker', component: GpsDataEntryComponent },
  { path: 'trucks/tracker/:imei', component: GpsDataEntryComponent },
  { path: 'vessels', component: VesselsComponent },
  { path: 'vessels/crew-change/crew-change-data-entry/:id', component: CrewChangeComponent },
  { path: 'vessels/crew-change/crew-change-data-entry/:id/:crewChangeId', component: CrewChangeComponent },
  { path: 'vessels/crew-change/crew/:id', component: CrewComponent },
  { path: 'vessels/crew-change/crew', component: CrewComponent },
  { path: 'vessels/crew-change/crew/profile/:id', component: CrewProfileComponent },
  { path: 'vessels/crew-change/crew-changes', component: CrewChangeListComponent },
  { path: 'vessels/crew-change/appraisal/:id', component: CrewAppraisalComponent },
  { path: 'vessels/fleet-personnel-management', component: FleetPersonnelManagementComponent },
  { path: 'vessels/crew-appraisals-table', component: CrewsAppraisalsComponent },
  { path: 'vessels/nautical-mile', component: NauticalMileComponent },
  { path: 'vessels/reports', component: VoyageReportsComponent },
  { path: 'vessels/voyages', component: VoyagesComponent },
  { path: 'vessels/voyage', component: NewVoyageComponent },
  { path: 'vessels/off-hire', component: VesselOffHireComponent },
  { path: 'vessels/off-hire/:id', component: VesselOffHireComponent },
  { path: 'vessels/off-hires', component: VesselsOffHiresComponent },
  { path: 'vessels/planner', component: VoyagePlannerComponent },
  { path: 'vessels/management-budget', component: VesselManagementCostComponent },
  { path: 'vessels/bunkers', component: BunkerListComponent },
  { path: 'vessels/bunker', component: BunkerDataEntryComponent },
  { path: 'vessels/bunker/:vesselImo/:product/:date/:bdnNumber', component: BunkerDataEntryComponent },
  { path: 'vessels/noon-reports/v202005', component: NoonReportsV202005Component },
  { path: 'vessels/noon-reports/v202205', component: NoonReportsV202205Component },
  { path: 'vessels/noon-reports/import-noon-report', component: ImportNoonReportComponent },
  { path: 'vessels/noon-reports/analysis', component: FuelAnalysisComponent },
  { path: 'vessels/noon-reports/latest-report', component: FleetSummeryReportComponent },
  { path: 'vessels/sea-shark-status', component: SeaSharkStatusComponent },
  { path: 'vessels/certificate/:imo', component: CertificateComponent },
  { path: 'vessels/certificate/:imo/:name', component: CertificateComponent },

  { path: 'vessels/status', component: FleetStatusComponent },
  { path: 'vessels/summery-report', component: FleetStatusComponent },
  { path: 'vessels/navigation-history', component: FleetNavigationHistoryComponent },
  { path: 'vessels/bunker', component: BunkerStatusComponent },
  { path: 'vessels/loading-time', component: LoadingTimeComponent },
  { path: 'vessels/voyage/:id', component: VoyageComponent },
  { path: 'vessels/voyage/:id/bl', component: BlComponent },
  { path: 'vessels/voyage/:id/nor', component: NorComponent },
  { path: 'vessels/voyage/:id/sof', component: SofComponent },
  { path: 'vessels/voyage/:id/discharge', component: DischargeComponent },
  { path: 'vessels/voyage/:id/comment', component: CommentComponent },
  { path: 'vessels/voyage/:id/misdoc', component: MiscDocumentComponent },
  { path: 'vessels/voyage/:id/charterer', component: ChartererComponent },
  { path: 'vessels/sof/sof-entry', component: SofEntryComponent },
  { path: 'vessels/sof-templates', component: SofTemplatesComponent },
  { path: 'vessels/sof/sof-template/:id', component: SofTemplateComponent },
  { path: 'vessels/sof/sof-template', component: SofTemplateComponent },
  { path: 'vessels/vessel-information/:imo', component: VesselInformationComponent },
  { path: 'vessels/vessel/internal-audit', component: VesselInternalAuditComponent },
  { path: 'vessels/vessel/:imo', component: VesselDataEntryComponent },
  { path: 'vessels/vessel/spec/:imo', component: VesselSpecComponent },
  { path: 'vessels/vessel', component: NewVesselComponent },
  { path: 'vessels/freshwaters', component: FreshWatersComponent },
  { path: 'vessels/fresh-water', component: FreshWaterComponent },
  { path: 'vessels/fresh-water/:vesselImo/:fdnNumber/:date', component: FreshWaterComponent },
  { path: 'vessels/oils', component: OilsComponent },
  { path: 'vessels/oil', component: OilDataEntryComponent },
  { path: 'vessels/oil/:vesselImo/:odnNumber/:product/:date', component: OilDataEntryComponent },
  { path: 'vessels/vessels-manual/:imo', component: VesselManualComponent },
  { path: 'vessels/hello-help', component: HelloHelpComponent },
  { path: 'vessels/hello-release', component: HelloReleaseComponent },
];
